import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [51.49933, -0.110768, 22],
  [51.499346, -0.110555, 23],
  [51.499368, -0.110359, 24],
  [51.4994, -0.110159, 25],
  [51.499406, -0.10996, 25.8],
  [51.499384, -0.109768, 26.8],
  [51.499336, -0.109581, 27.8],
  [51.499287, -0.109405, 28.8],
  [51.499234, -0.109231, 29.8],
  [51.499175, -0.109062, 30.8],
  [51.499116, -0.1089, 31.6],
  [51.499051, -0.108736, 32.6],
  [51.498992, -0.108576, 33.6],
  [51.498928, -0.108418, 34.6],
  [51.498858, -0.108267, 35.6],
  [51.498794, -0.108112, 36.6],
  [51.49873, -0.107959, 37.6],
  [51.49866, -0.107808, 38.4],
  [51.498595, -0.10766, 39.4],
  [51.498531, -0.107515, 40.4],
  [51.498461, -0.107371, 41.4],
  [51.498386, -0.107231, 42.4],
  [51.498306, -0.107107, 43.4],
  [51.49822, -0.106993, 44.4],
  [51.49814, -0.106868, 45.4],
  [51.498064, -0.106734, 46.2],
  [51.497989, -0.106599, 47],
  [51.497914, -0.106459, 47.8],
  [51.497844, -0.10632, 48.6],
  [51.497769, -0.10618, 49.4],
  [51.497694, -0.106037, 50.2],
  [51.497619, -0.105894, 51],
  [51.497544, -0.10575, 51.8],
  [51.497474, -0.105602, 52.4],
  [51.497399, -0.105455, 53.2],
  [51.497329, -0.105304, 53.8],
  [51.497249, -0.105148, 54.4],
  [51.497174, -0.104996, 55.2],
  [51.497099, -0.10484, 55.8],
  [51.497024, -0.104688, 56.4],
  [51.496938, -0.104534, 57],
  [51.496852, -0.104391, 57.6],
  [51.496755, -0.104252, 58.2],
  [51.496659, -0.10412, 58.8],
  [51.496562, -0.103995, 59.6],
  [51.496455, -0.10388, 60.4],
  [51.496342, -0.103778, 61.2],
  [51.49623, -0.103692, 62.2],
  [51.496117, -0.103611, 63],
  [51.496004, -0.103531, 64],
  [51.495886, -0.10346, 64.8],
  [51.495768, -0.103397, 65.8],
  [51.49565, -0.103341, 66.8],
  [51.495538, -0.103279, 67.6],
  [51.495436, -0.103186, 68.2],
  [51.495377, -0.103015, 68.8],
  [51.495425, -0.102842, 69.2],
  [51.495543, -0.102768, 69.4],
  [51.495672, -0.102732, 70.4],
  [51.495795, -0.102745, 71.4],
  [51.495913, -0.102789, 72.4],
  [51.496037, -0.102845, 73.2],
  [51.496155, -0.102904, 74],
  [51.496273, -0.102964, 74.6],
  [51.496391, -0.103025, 75.4],
  [51.496509, -0.10309, 76],
  [51.496627, -0.103156, 76.8],
  [51.496745, -0.103232, 77.6],
  [51.496857, -0.103322, 78.2],
  [51.49697, -0.103415, 79],
  [51.497077, -0.103511, 79.8],
  [51.497185, -0.103612, 80.6],
  [51.497297, -0.103721, 81.2],
  [51.497399, -0.103836, 82],
  [51.497501, -0.103953, 82.8],
  [51.497603, -0.10407, 83.4],
  [51.497705, -0.104192, 84.2],
  [51.497807, -0.104315, 85],
  [51.497909, -0.104436, 85.6],
  [51.498005, -0.104558, 86.4],
  [51.498113, -0.104676, 87],
  [51.498215, -0.104788, 87.6],
  [51.498322, -0.104901, 88.4],
  [51.498424, -0.105025, 89],
  [51.49852, -0.105166, 89.8],
  [51.498628, -0.105268, 90.4],
  [51.498751, -0.105228, 91],
  [51.498805, -0.105044, 91.4],
  [51.498767, -0.104851, 92],
  [51.498671, -0.104702, 92.6],
  [51.498569, -0.104582, 93],
  [51.498456, -0.104454, 93.6],
  [51.498359, -0.104312, 94.4],
  [51.498263, -0.104168, 95],
  [51.498161, -0.104021, 95.8],
  [51.49807, -0.103877, 96.4],
  [51.497973, -0.103726, 97.2],
  [51.497887, -0.103574, 97.8],
  [51.497796, -0.103417, 98.4],
  [51.49771, -0.103258, 99],
  [51.497619, -0.103101, 99.8],
  [51.497533, -0.102943, 100.4],
  [51.497447, -0.102791, 101.4],
  [51.497356, -0.102641, 102.2],
  [51.49726, -0.10249, 103],
  [51.497174, -0.102347, 104],
  [51.497077, -0.102211, 104.8],
  [51.496975, -0.102094, 105.6],
  [51.496868, -0.101999, 106.2],
  [51.496755, -0.101901, 106.8],
  [51.496648, -0.101789, 107.6],
  [51.496541, -0.101673, 108.2],
  [51.496439, -0.101555, 109],
  [51.496332, -0.101438, 109.6],
  [51.49623, -0.101324, 110.4],
  [51.496117, -0.101209, 111],
  [51.49601, -0.101098, 111.8],
  [51.495903, -0.100992, 112.4],
  [51.49579, -0.100889, 113.2],
  [51.495677, -0.100796, 113.8],
  [51.495559, -0.100711, 114.6],
  [51.495441, -0.10063, 115.2],
  [51.495323, -0.100553, 115.8],
  [51.4952, -0.100479, 116.4],
  [51.495082, -0.100404, 117.2],
  [51.494958, -0.100327, 117.8],
  [51.494835, -0.100254, 118.6],
  [51.494712, -0.100184, 119.4],
  [51.494594, -0.100105, 120],
  [51.494481, -0.100015, 120.8],
  [51.494368, -0.099921, 121.6],
  [51.49425, -0.099826, 122.4],
  [51.494138, -0.099731, 123],
  [51.494025, -0.099636, 123.8],
  [51.493912, -0.09954, 124.6],
  [51.4938, -0.099443, 125.4],
  [51.493682, -0.099355, 126],
  [51.493569, -0.099268, 126.6],
  [51.493451, -0.099182, 127.2],
  [51.493338, -0.099091, 128],
  [51.493226, -0.098991, 128.6],
  [51.493113, -0.09889, 129.4],
  [51.493, -0.098785, 130.2],
  [51.492893, -0.098685, 131],
  [51.49278, -0.09858, 131.6],
  [51.492668, -0.098476, 132.4],
  [51.492561, -0.098374, 133.2],
  [51.492448, -0.098269, 134],
  [51.492341, -0.098167, 134.6],
  [51.492233, -0.098064, 135.4],
  [51.492121, -0.09796, 136],
  [51.492008, -0.097854, 136.6],
  [51.49189, -0.097762, 137],
  [51.491767, -0.097777, 137.6],
  [51.491675, -0.097921, 138],
  [51.491643, -0.098125, 138.4],
  [51.491649, -0.098339, 138.6],
  [51.49167, -0.098558, 139],
  [51.491691, -0.098774, 139.4],
  [51.491691, -0.098993, 140.4],
  [51.491691, -0.099215, 141.2],
  [51.491691, -0.09943, 142],
  [51.491681, -0.099642, 142.4],
  [51.491665, -0.099862, 142.6],
  [51.491649, -0.100078, 143],
  [51.491622, -0.100291, 143.4],
  [51.491563, -0.100497, 143.8],
  [51.491493, -0.100688, 143.8],
  [51.491423, -0.100891, 143.8],
  [51.491332, -0.101078, 143.6],
  [51.491203, -0.10117, 143.6],
  [51.491053, -0.101171, 143.4],
  [51.490898, -0.101119, 143.2],
  [51.490763, -0.101017, 143.2],
  [51.490624, -0.100901, 143.2],
  [51.490474, -0.100842, 143.2],
  [51.490318, -0.100845, 143.2],
  [51.490157, -0.100893, 142.8],
  [51.490002, -0.100945, 142.4],
  [51.489835, -0.100959, 142.2],
  [51.489685, -0.100864, 142],
  [51.489605, -0.100642, 141.8],
  [51.489508, -0.100419, 141.6],
  [51.489412, -0.100207, 141.2],
  [51.489315, -0.09999, 140.8],
  [51.489272, -0.099729, 140.6],
  [51.489256, -0.09945, 140.4],
  [51.489245, -0.099185, 140.4],
  [51.489256, -0.098916, 140.2],
  [51.489272, -0.098645, 140],
  [51.48931, -0.098381, 140],
  [51.489374, -0.098121, 140],
  [51.489455, -0.09789, 140],
  [51.48953, -0.097654, 140],
  [51.489605, -0.09741, 139.8],
  [51.48968, -0.097175, 140],
  [51.48976, -0.096938, 140.4],
  [51.489841, -0.096709, 141.2],
  [51.489889, -0.096468, 141.8],
  [51.489905, -0.096215, 142],
  [51.489921, -0.095965, 142.2],
  [51.489927, -0.095707, 142.2],
  [51.489932, -0.09545, 142.2],
  [51.489943, -0.095195, 142.2],
  [51.489943, -0.09494, 142],
  [51.489943, -0.094686, 141.8],
  [51.489937, -0.094417, 141.4],
  [51.489932, -0.094152, 140.8],
  [51.489927, -0.09389, 140.4],
  [51.489921, -0.09362, 140],
  [51.489916, -0.093342, 139.4],
  [51.489905, -0.093071, 139],
  [51.489905, -0.092795, 138.8],
  [51.489916, -0.092517, 138.8],
  [51.489932, -0.092246, 139.2],
  [51.489937, -0.091974, 140.2],
  [51.489943, -0.091719, 141.8],
  [51.489932, -0.091474, 143.4],
  [51.489921, -0.091238, 145],
  [51.4899, -0.091016, 146.6],
  [51.489878, -0.090802, 148],
  [51.489857, -0.090589, 149.4],
  [51.489841, -0.090388, 150.6],
  [51.489819, -0.090193, 152],
  [51.489803, -0.090001, 153.2],
  [51.489782, -0.08981, 154.2],
  [51.48976, -0.089626, 155],
  [51.489733, -0.089439, 155.4],
  [51.489696, -0.089251, 155.4],
  [51.489664, -0.089053, 155],
  [51.489632, -0.088837, 154.4],
  [51.489605, -0.088614, 153.6],
  [51.489578, -0.088382, 152.4],
  [51.489551, -0.088134, 151.2],
  [51.489524, -0.087873, 149.4],
  [51.489508, -0.087597, 147.4],
  [51.489503, -0.087311, 145.6],
  [51.489508, -0.087008, 143.8],
  [51.489508, -0.086706, 142],
  [51.489519, -0.086395, 140.2],
  [51.489535, -0.086079, 138.4],
  [51.489551, -0.085762, 136.6],
  [51.489567, -0.085441, 135],
  [51.489589, -0.08511, 133.2],
  [51.489605, -0.08478, 131.6],
  [51.489632, -0.084456, 129.8],
  [51.489664, -0.084122, 128],
  [51.489707, -0.083795, 126.2],
  [51.489766, -0.083467, 124.2],
  [51.48983, -0.083144, 122.4],
  [51.489889, -0.082815, 120.2],
  [51.489969, -0.082497, 118.2],
  [51.490077, -0.082193, 116],
  [51.490238, -0.081956, 113.8],
  [51.490442, -0.081848, 111.8],
  [51.490662, -0.081863, 110.4],
  [51.490871, -0.081922, 109.4],
  [51.49108, -0.081993, 108.4],
  [51.491295, -0.082065, 107.4],
  [51.491498, -0.082108, 106.4],
  [51.491702, -0.082084, 105.2],
  [51.491874, -0.081907, 103.8],
  [51.491954, -0.081599, 102.6],
  [51.491981, -0.081275, 101.4],
  [51.491987, -0.080943, 100.4],
  [51.491987, -0.080613, 99.4],
  [51.491997, -0.080286, 98.4],
  [51.492046, -0.079971, 97.4],
  [51.492147, -0.079695, 96.2],
  [51.492282, -0.079446, 95.2],
  [51.492421, -0.079227, 94.4],
  [51.492577, -0.079025, 93.6],
  [51.492748, -0.078854, 92.6],
  [51.492931, -0.078741, 91.6],
  [51.493129, -0.078708, 90.4],
  [51.493312, -0.078808, 88.8],
  [51.493472, -0.07901, 87.4],
  [51.493607, -0.079247, 86],
  [51.493735, -0.079497, 84.8],
  [51.493859, -0.079758, 83.4],
  [51.493977, -0.080017, 82.2],
  [51.494105, -0.080284, 81],
  [51.494223, -0.080533, 79.8],
  [51.494368, -0.080766, 78.4],
  [51.494551, -0.08092, 76.8],
  [51.494755, -0.08092, 75.6],
  [51.494937, -0.080769, 74.6],
  [51.495071, -0.080538, 73.8],
  [51.495184, -0.080264, 72.4],
  [51.495248, -0.079955, 70.6],
  [51.495259, -0.079626, 68.6],
  [51.495253, -0.079298, 66.6],
  [51.495237, -0.078958, 64.4],
  [51.495232, -0.078614, 62],
  [51.495232, -0.078273, 59.4],
  [51.495216, -0.077923, 56.4],
  [51.4952, -0.077561, 53.4],
  [51.495184, -0.077209, 50.4],
  [51.495173, -0.076837, 47.4],
  [51.495184, -0.076471, 44.4],
  [51.495211, -0.076102, 41.6],
  [51.495259, -0.075739, 39.2],
  [51.495334, -0.075377, 36.8],
  [51.495414, -0.075036, 34.8],
  [51.495506, -0.074696, 32.8],
  [51.495613, -0.074378, 31.2],
  [51.495731, -0.074074, 29.6],
  [51.495876, -0.073784, 28],
];

export default stream;
